const React = require('react');
const withState = require('../../../../utils/withState');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const {apiAdminMonthlyPaymentOverview, apiAdminPaymentOverview, apiAdminPendingWithdrawalsOverview} = require("../../../../api/admin/statistic");
const FieldA = require("../../../dumb/Field/A");
const Switch = require("../../../dumb/Switch/D");
const KeyboardDatePickerD = require("../../../dumb/KeyboardDatePicker/D");

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    loading: true,
    isCurrentMonth: true,
    date: new Date()
  }

  const onSwitchChange = () => {
    const isCurrentMonth = !self.state.isCurrentMonth;

    setState({isCurrentMonth, monthlyLoading: true})

    const fn = isCurrentMonth
      ? () => apiAdminMonthlyPaymentOverview()
      : () => {
        const date = self.state.date;
        return apiAdminPaymentOverview({month: date.getMonth() + 1, year: date.getFullYear()});
      }

    return fn().then((res) => {
      setState({
        monthlyLoading: false,
        fees_volume_eur: res.monthly_fees_volume_eur || res.fees_volume_eur,
        order_volume_eur: res.monthly_order_volume_eur || res.order_volume_eur
      })
    });
  }

  const onDateChange = (date) => {
    setState({date});

    apiAdminPaymentOverview({month: date.getMonth() + 1, year: date.getFullYear()})
      .then((monthlyPaymentData) => {
        setState({
          ...monthlyPaymentData
        })
      });
  }

  onMount(() => {
    Promise.all([
      apiAdminMonthlyPaymentOverview(),
      apiAdminPendingWithdrawalsOverview()
    ]).then((res) => {
      const [monthlyPaymentData, pendingWithdrawalOverview] = res;

      setState({
        fees_volume_eur: monthlyPaymentData.monthly_fees_volume_eur,
        order_volume_eur: monthlyPaymentData.monthly_order_volume_eur,
        total_pending_withdrawals_eur: pendingWithdrawalOverview.total_pending_withdrawals_eur,
        total_pending_withdrawals_detailed: pendingWithdrawalOverview.detailed,
        loading: false
      })
    });
  })
  return (state) => {

    const {isCurrentMonth, date} = state;
    const monthPrefix = isCurrentMonth ? 'Current' : 'Custom';

    return (
      <LayoutA>
        <HeaderA>
          <CaptionA>Monthly Statistic</CaptionA>
          <div className="layoutRow">
            <div className="layoutRow aiC (crP):h" onClick={onSwitchChange}>
            <span
              className={`dB mr15 f12 fw7 lh18 o70 o100:h (o100|o70:h).active` + (isCurrentMonth ? ' active' : '')}
            >Current Month</span>
              <Switch
                className={
                  `(bcF)>.SwitchC_Btn (bcF)>.SwitchC_Btn:not[.disabled]:h 
                (bgF)>.SwitchC_Circle.checked 
                (bgF-i)>.SwitchC_Btn:not[.disabled]:h>.SwitchC_Circle.checked`
                }
                // label="Current Month"
                checked={!isCurrentMonth}
                onClick={onSwitchChange}
              />
              <span
                className={`dB ml15 f12 fw7 lh18 o70 o100:h (o100|o70:h).active` + (!isCurrentMonth ? ' active' : '')}
              >Custom Month</span>
            </div>
            {!isCurrentMonth && (
              <div className="w300 ml20">
                <KeyboardDatePickerD
                  format="MM.yyyy"
                  disableFuture
                  label="Custom month"
                  value={date}
                  onChange={onDateChange}
                  views={['month', 'year']}
                />
              </div>
            )}
          </div>
        </HeaderA>
        <WrapperWithLoading loading={state.loading || state.monthlyLoading}>
          <div className="layoutRow m-15 (p15)>1">
            <div>
              <FieldA label={`${monthPrefix} order volume`}>
                {state.order_volume_eur || '0'} EUR
              </FieldA>
            </div>
            <div>
              <FieldA label={`${monthPrefix} fees volume`}>
                {state.fees_volume_eur || '0'} EUR
              </FieldA>
            </div>
          </div>
        </WrapperWithLoading>
        <HeaderA>
          <CaptionA>Withdrawal Data</CaptionA>
        </HeaderA>
        <WrapperWithLoading loading={state.loading}>
          <div className="mt20">
            <FieldA label="Total pending withdrawal order volume">
              {state.total_pending_withdrawals_eur || '0'} EUR
            </FieldA>
          </div>
          <div>
            <div className="cA4A7AC f12 fw5">Detailed pending withdrawal order</div>
            <ul>
              {Object.keys(state.total_pending_withdrawals_detailed || {}).map((symbol) => {
                return (
                  <li key={symbol} className="mt5">
                    {state.total_pending_withdrawals_detailed[symbol] || 0} {symbol}
                  </li>
                )
              })}
            </ul>
          </div>
        </WrapperWithLoading>
      </LayoutA>
    )
  }
})
